import {
  APILibraryTemplate,
  type APILibraryTemplateResponseType,
  type IAPILibraryTemplate,
} from "@/core/data_sources/models/APILibraryTemplate";
import { State } from "@/core/data_sources/store/state";

export type LibraryTemplatesStateType = {
  list: IAPILibraryTemplate[];
  count?: number;
};

export class LibraryTemplatesState extends State<LibraryTemplatesStateType> {
  constructor() {
    super({ list: [], count: 0 });
  }

  setTemplates(templates: APILibraryTemplateResponseType[]) {
    this._observable.next({
      list: templates.map((template) => new APILibraryTemplate(template)),
    });
  }

  setCount(count: number) {
    this._observable.next({
      ...(this._observable.value ?? { list: [], count: 0 }),
      count,
    });
  }

  clear(): void {
    this._observable.next({ list: [], count: 0 });
  }
}
